import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    showMore: translate({ id: 'preview.form.tagsList.button.showMore' }),
    showLess: translate({ id: 'preview.form.tagsList.button.showLess' }),
  }))

  return api
}
